import React, { useCallback, useEffect, useState } from 'react'
import { CAlert, CButton, CCol, CRow } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilReload, cilWarning } from '@coreui/icons'
import CommonService from 'src/service/CommonService'
import ToastComponent from 'src/components/common/TaostComponent'
import Potm from './Potm'
import ResultBonus from './ResultBonus'
import './BonusPoint.css'

const BonusPoint = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [loadingPotm, setLoadingPotm] = useState(false)
  const [loadingResultBonus, setLoadingResultBonus] = useState(false)

  const loadData = useCallback(() => {
    setLoading(true)
    setError(false)
    CommonService.getBonusPoint()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data || [])
        } else {
          setError(true)
        }
      })
      .catch(() => {
        setError(true)
        ToastComponent('Something went wrong. Please try again.', 'error')
      })
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    loadData()
  }, [loadData])

  return (
    <>
      <div className="ge-page-header">
        <h1 className="ge-page-title">Bonus Points</h1>
        <p className="ge-page-subtitle">
          Set the extra fantasy points each team&apos;s players earn for Player of the Match and for
          winning a fixture.
        </p>
      </div>

      {error && (
        <CAlert color="danger" className="d-flex flex-wrap align-items-center gap-2">
          <CIcon icon={cilWarning} className="flex-shrink-0" />
          <span>We couldn&apos;t load bonus points. Nothing has been changed.</span>
          <CButton
            color="danger"
            variant="outline"
            size="sm"
            className="ms-auto"
            onClick={loadData}
          >
            <CIcon icon={cilReload} className="me-1" />
            Retry
          </CButton>
        </CAlert>
      )}

      <CRow className="g-3">
        <CCol xs={12}>
          <Potm
            data={data}
            loading={loading}
            loadingPotm={loadingPotm}
            setLoadingPotm={setLoadingPotm}
          />
        </CCol>
        <CCol xs={12}>
          <ResultBonus
            data={data}
            loading={loading}
            loadingResultBonus={loadingResultBonus}
            setLoadingResultBonus={setLoadingResultBonus}
          />
        </CCol>
      </CRow>
    </>
  )
}

export default BonusPoint
